$(document).ready(function(){

        $(".product-loop-container").eq(0).mouseenter(function() {
            $(".product-loop-view-btn").eq(0).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(0).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(0).css("animation-name", "none"); 
            $(".product-loop-title").eq(0).css("animation-name", "none"); 
        });
    
         $(".product-loop-container").eq(1).mouseenter(function() {
            $(".product-loop-view-btn").eq(1).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(1).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(1).css("animation-name", "none"); 
            $(".product-loop-title").eq(1).css("animation-name", "none"); 
        });
    
         $(".product-loop-container").eq(2).mouseenter(function() {
            $(".product-loop-view-btn").eq(2).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(2).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(2).css("animation-name", "none"); 
            $(".product-loop-title").eq(2).css("animation-name", "none"); 
        });
    
         $(".product-loop-container").eq(3).mouseenter(function() {
            $(".product-loop-view-btn").eq(3).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(3).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(3).css("animation-name", "none"); 
            $(".product-loop-title").eq(3).css("animation-name", "none"); 
        });
    
         $(".product-loop-container").eq(4).mouseenter(function() {
            $(".product-loop-view-btn").eq(4).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(4).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(4).css("animation-name", "none"); 
            $(".product-loop-title").eq(4).css("animation-name", "none"); 
        });
    
         $(".product-loop-container").eq(5).mouseenter(function() {
            $(".product-loop-view-btn").eq(5).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(5).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(5).css("animation-name", "none"); 
            $(".product-loop-title").eq(5).css("animation-name", "none"); 
        });
    
         $(".product-loop-container").eq(6).mouseenter(function() {
            $(".product-loop-view-btn").eq(6).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(6).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(6).css("animation-name", "none"); 
            $(".product-loop-title").eq(6).css("animation-name", "none"); 
        });
    
         $(".product-loop-container").eq(7).mouseenter(function() {
            $(".product-loop-view-btn").eq(7).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(7).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(7).css("animation-name", "none"); 
            $(".product-loop-title").eq(7).css("animation-name", "none"); 
        });
         $(".product-loop-container").eq(8).mouseenter(function() {
            $(".product-loop-view-btn").eq(8).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(8).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(8).css("animation-name", "none"); 
            $(".product-loop-title").eq(8).css("animation-name", "none"); 
        });
         $(".product-loop-container").eq(9).mouseenter(function() {
            $(".product-loop-view-btn").eq(9).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(9).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(9).css("animation-name", "none"); 
            $(".product-loop-title").eq(9).css("animation-name", "none"); 
        });
         $(".product-loop-container").eq(10).mouseenter(function() {
            $(".product-loop-view-btn").eq(10).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(10).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(10).css("animation-name", "none"); 
            $(".product-loop-title").eq(10).css("animation-name", "none"); 
        });
         $(".product-loop-container").eq(11).mouseenter(function() {
            $(".product-loop-view-btn").eq(11).css("animation-name", "loop").css("animation-duration", "0.8s").css("animation-fill-mode", "forwards");
            $(".product-loop-title").eq(11).css("animation-name", "looptitle").css("animation-duration", "0.8s").css("animation-fill-mode","forwards");
        }).mouseleave(function(){ 
            $(".product-loop-view-btn").eq(11).css("animation-name", "none"); 
            $(".product-loop-title").eq(11).css("animation-name", "none"); 
        });
    
});




